if (!customElements.get('mera-contrast-button')) {
  class MeraContrastButton extends HTMLElement {

    get isEnabled() {
      return localStorage.getItem('mera-a11y-enabled') === 'true';
    }

    set isEnabled(value) {
      localStorage.setItem('mera-a11y-enabled', value);
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.toggleClass(this.isEnabled);

      this.addEventListener('click', (e) => {
        this.isEnabled = !this.isEnabled;
        this.toggleClass(this.isEnabled);
      });

      this.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this.isEnabled = !this.isEnabled;
          this.toggleClass(this.isEnabled);
        }
      });
    }

    toggleClass(enable) {
      const a11yClass = 'a11y';
      const enabledClass = 'mera-contrast-button__enabled';

      if (enable) {
        document.body.classList.add(a11yClass);
        this.classList.add(enabledClass);
      } else {
        document.body.classList.remove(a11yClass);
        this.classList.remove(enabledClass);
      }
    }
  }

  customElements.define('mera-contrast-button', MeraContrastButton);
}